export const USER_DELETED_ERROR = 'user_deleted';

export class ApiErrorHandler {
    static isUserDeleted(response) {
        return response && !response.success && response.error === USER_DELETED_ERROR;
    }

    static handleUserDeletedError() {
        return {
            isUserDeleted: true,
            error: USER_DELETED_ERROR
        };
    }
}
